// velodrome-icons.tsx
// Clean React + Tailwind-friendly velodrome icons.
// All icons inherit `currentColor` for easy theming.
//
// Usage:
//   import { VelodromeIndoorIcon, VelodromeOutdoorIcon } from "./velodrome-icons";
//   <VelodromeOutdoorIcon className="w-8 h-8 text-amber-500" />
//   <VelodromeIndoorIcon className="w-10 h-10 text-gray-800" />

import * as React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

/** Core tilted oval track — reused in all icons */
export const VelodromeOval: React.FC<Props> = ({ className = 'w-6 h-6', ...props }) => (
  <svg
    viewBox="0 0 120 70"
    fill="none"
    stroke="currentColor"
    strokeWidth={4}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <g transform="rotate(-10 60 35)">
      {/* Outer track */}
      <path d="M20 35c0-12 18-22 40-22s40 10 40 22-18 22-40 22-40-10-40-22z" />
      {/* Inner track */}
      <path d="M30 35c0-8 14-15 30-15s30 7 30 15-14 15-30 15-30-7-30-15z" />
    </g>
  </svg>
);

/** Indoor velodrome with a simple V-roof */
export const VelodromeIndoorIcon: React.FC<Props> = ({ className = 'w-6 h-6', ...props }) => (
  <svg
    viewBox="0 0 120 90"
    fill="none"
    stroke="currentColor"
    strokeWidth={4}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Roof */}
    <path d="M25 15 L60 5 L95 15" />
    {/* Velodrome body */}
    <VelodromeOval className="w-full h-auto" />
  </svg>
);

/** Outdoor velodrome with sun in top-left */
export const VelodromeOutdoorIcon: React.FC<Props> = ({ className = 'w-6 h-6', ...props }) => (
  <svg
    viewBox="0 0 120 90"
    fill="none"
    stroke="currentColor"
    strokeWidth={4}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Sun */}
    <circle cx="20" cy="20" r="6" fill="none" />
    <path d="M20 7v4M20 29v4M7 20h4M29 20h4M11 11l3 3M26 26l3 3M11 29l3-3M26 14l3-3" />
    {/* Velodrome body */}
    <VelodromeOval className="w-full h-auto" />
  </svg>
);

export default {
  VelodromeOval,
  VelodromeIndoorIcon,
  VelodromeOutdoorIcon,
};
